<template>
  <el-dialog title="物流产品报价详情"
             width="1200px"
             custom-class="product-quotation__edit-dialog"
             :visible.sync="visibleValue"
             :modal-append-to-body="true"
             :append-to-body="true"
             :close-on-press-escape="true"
             :close-on-click-modal="true"
             :show-close="false"
             @close="close"
             @closed="closedCallback">
    <div slot="title" class="dialog-title">
      <div>物流产品报价详情</div>
      <img :src="ossPath + '/pages/inquiryHall/ico-close-gray.png'" alt="关闭" @click="visibleValue = false">
    </div>
    <el-tabs class="tab-pane-style"
             @tab-click="changeTab"
             v-model="viewTypeListValue">
      <el-tab-pane v-for="item in viewTypeList"
                   :key="item.name"
                   :label="item.name"
                   :name="item.id">
        <template v-if="item.components && dataIsEmpty">
          <component :is="item.components"
                     :data="data"
                     :ref="item.id"
                     :state="state"
                     v-if="item.id === viewTypeListValue"></component>
        </template>
      </el-tab-pane>
      <el-tab-pane label="引用平台分段报价"
                   name="usePlatformQuotation">
        <div slot="label">
          引用平台分段报价
          <el-tooltip
            content=""
            placement="top-start"
            effect="dark">
            <i class="el-icon-question"/>
            <div slot="content">
              1.以下报价为分段供应商发布，供应商均经过平台严格筛选，可放心使用。
              <br/>
              2.引用分段报价后，需将对应分段的操作交由该公司负责，并支付相应费用。
            </div>
          </el-tooltip>
        </div>
        <el-form ref="editForm"
                 label-width="110px"
                 size="small"
                 :inline="true">
          <use-platform-quotation
            ref="viewUsePlatformQuotation"
            :country-name="data.podnamec"
            :country-id="data.podId"
            :use-delivery-supplier-id="data.smartCarrierId"
            is-view
          />
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <div class="footer-active" style="justify-content: center">
      <el-button type=""
                 class="footer-cancel"
                 @click="visibleValue=false"
                 size="medium">取消</el-button>
      <slot name="action" :data="data"></slot>
    </div>
  </el-dialog>
</template>

<script>
  import {templateDialog} from "../templateDialog";
  import ViewBaseInfo from './viewBaseInfo'
  import ViewFreightPrice from './viewFreightPrice'
  import ViewAddedServiceSetting from './viewAddedServiceSetting'
  import UsePlatformQuotation from "@/components/QuotationManagement/components-productQuotation/usePlatformQuotation";
  export default {
    name: "viewProductQuotationDetails",
    mixins:[templateDialog],
    components:{
      UsePlatformQuotation,
      ViewBaseInfo,
      ViewFreightPrice,
      ViewAddedServiceSetting,
    },
    props:{
      data:{
        type:Object,
      },
      state: {
        type:Number,
        default: 1
      }
    },
    data(){
      return {
        /* tab 选项卡 */
        viewTypeList: [
          {name: '基本信息', id: 'baseInfo',components: ViewBaseInfo},
          {name: '运费价格设置', id: 'freightPriceSetting',components: ViewFreightPrice},
          {name: '增值服务价格设置', id: 'addedServicePriceSetting',components: ViewAddedServiceSetting},
          // {name: '引用平台分段报价', id: 'usePlatformQuotation',},
        ],
        viewTypeListValue: 'baseInfo',
        haveQuerySmart:false,
      }
    },
    computed:{
      dataIsEmpty(){
        if(typeof this.data !== 'object') return false;
        if(this.data === null) return false;
        if(this.data instanceof Array) return false;
        if(Object.keys(this.data).length<=0) return false;
        return true;
      },
    },
    methods:{
      close(){
        this.viewTypeListValue = 'baseInfo';
        this.haveQuerySmart = false;
        let $usePlatformQuotation = this.$refs.viewUsePlatformQuotation;
        if($usePlatformQuotation && typeof $usePlatformQuotation.resetData === "function") $usePlatformQuotation.resetData();
      },
      changeTab(){
        if(this.viewTypeListValue === "usePlatformQuotation"){
          if(this.haveQuerySmart) return false;
          this.haveQuerySmart = true;
          this.$nextTick(()=>{
            let $usePlatformQuotation = this.$refs.viewUsePlatformQuotation;
            if($usePlatformQuotation && typeof $usePlatformQuotation.clickSearch === "function") $usePlatformQuotation.clickSearch();
          })
        }

      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/components-productQuotation/viewDetails/viewProductQuotationDetails.vue